import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8oy7a20lz0: FaireBrandEntity = {
  token: "b_8oy7a20lz0",
  type: "brand",
  name: "ESW Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/b33caf6e86e758b2afa5c4f4b83efa3333c284f2cc32a60b20fd9970eaadea08.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7a4dcb23702cac0493e3af129b7ae9786316b74496109fee31e0eb1d788def0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b33caf6e86e758b2afa5c4f4b83efa3333c284f2cc32a60b20fd9970eaadea08.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7a4dcb23702cac0493e3af129b7ae9786316b74496109fee31e0eb1d788def0.jpeg",
  location: "Hazlet, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 206,
  isInsider: true,
  description:
    "At ESW Beauty, we create wellness-inspired skincare with clean, high-performing formulas powered by targeted actives and skin-friendly formulas designed to deliver real results. Our beverage-inspired assortment includes best-selling Raw Juice Sheet Masks, Latte Eye Patches, and Smoothie Lip Treatments—trend-forward categories that resonate with today’s beauty consumer and perform strongly at retail.\n\nFounded in 2019 by Elina Sofia Wang, ESW Beauty was inspired by her personal wellness journey and a vision to merge inner wellness with effective skincare. Since launch, we’ve grown rapidly and are now sold in 15,000+ boutiques and retailers nationwide. We’re known for strong sell-through, approachable price points, and packaging designed to educate shoppers and simplify the path to purchase.\n \nAll ESW Beauty products are:\n\n🌱Clean, vegan, and cruelty-free\n🐇 Leaping Bunny Certified\n🚫 Free of parabens, phthalates, synthetic fragrances, formaldehyde, and sulfate detergents\n🌎 Thoughtfully designed with sustainability in mind\n🇰🇷 Made in Korea \n\n\n✨Rebrand Update✨\n\nWe are currently rolling out refreshed branding with bolder visuals, brighter colors, and clearer skin-benefit callouts, while maintaining the same trusted formulas. During this transition, orders may include a mix of original and updated packaging as inventory sells through.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:59.564Z",
    importedBy: "entity-db-cli",
  },
};
